const proposalProcessQuestionType = Object.freeze({
  individualRP: 838,
  companyRP: 839,
  dbaRP: 840,
  individualSAEE: 874,
  companySAEE: 875,
  dbaSAEE: 876,
});

export default proposalProcessQuestionType;
